import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../button';
import { Col } from '../../col';
import { Row } from '../../row';
import { Title } from '../../typography';

export type ControlsProperties = {
  seeAll?: { limit?: number; onClick?: () => void; total?: number };
  title?: ReactNode;
  titleIcon?: ReactNode;
  titleLevel?: 2 | 4;
};

const SliderControls = ({ seeAll, title, titleIcon, titleLevel = 2 }: ControlsProperties) => {
  const { t } = useTranslation();
  const { limit = 10, onClick, total } = seeAll ?? {};
  const hasSeeAllButton = onClick && (total === undefined || total > limit);

  return (
    <Row align="middle" className="slider-controls" justify="space-between">
      <Col>
        <Title icon={titleIcon} level={titleLevel}>
          {typeof title === 'string' ? t(title) : title}
        </Title>
      </Col>
      {hasSeeAllButton ? (
        <Col>
          <Button onClick={() => seeAll?.onClick?.()} type="link-primary">
            See all
          </Button>
        </Col>
      ) : null}
    </Row>
  );
};

export default SliderControls;
